"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var translate_1 = require("utils/translate");
var sok_ui_1 = require("@caddigital/sok-ui");
var participantsActions = require("@caddigital/sok-reducers/lib/actions/bid/participants");
var Types = require("types");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        usersGroups: state.bid.userGroups.list,
        selectedLanguage: selectedLanguage,
        selected: state.bid.participants.selected
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(participantsActions.toggleAddParticipant()); },
    toggleCopyModal: function () { return dispatch(participantsActions.toggleCopyParticipant()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BidParticipantsTools'), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
exports.Tools = enhance(function (props) { return (React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'briefcase-view-tools-container' },
    React.createElement(sok_ui_1.ToolsSidebar, { className: 'briefcaseView-tools', headerText: (0, translation_1.getLocalization)('bid/messagesView/tools/header') },
        React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.currentBid.id, "/message"), className: 'sok-tool-button green' },
            React.createElement(sok_ui_1.Icon, { className: 'fa-plus sok-tool-button-icon' }),
            React.createElement("span", { className: 'sok-tool-button-text' }, (0, translation_1.getLocalization)('bid/messagesView/tools/createMessage'))),
        React.createElement(sok_ui_1.ToolButton, { color: 'gray', text: (0, translation_1.getLocalization)('bid/messagesView/tools/downloadReport'), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-file-excel' }) })))); });
